export const expositores = [
    { logo: require("../../assets/images/logos/edelvives.jpg") },
    { logo: require("../../assets/images/logos/anaya.png") },
    { logo: require("../../assets/images/logos/edebe.png") },
    { logo: require("../../assets/images/logos/solaer.jpg") },
    { logo: require("../../assets/images/logos/smartick.png") },
    { logo: require("../../assets/images/logos/UFV.jpg") },
];